(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-tabs"] && !Shopify.designMode) return;
  try {
    


// document.addEventListener("DOMContentLoaded", function () {

//   const tabs = document.querySelectorAll(".tab-link-nav-cstm");

//   tabs.forEach(tab => {
//     tab.addEventListener("click", function (e) {
//       e.preventDefault();

//       const handle = this.getAttribute("href").replace("?tab=", "");
//       const container = document.querySelector(`#${handle}`);

//       // Hide all
//       document.querySelectorAll(".tab-content-inner-wrap")
//         .forEach(el => el.style.display = "none");

//       container.style.display = "flex";

//       // Agar already loaded hai to dubara load mat karo
//       if (container.dataset.loaded === "true") return;

//       fetch(`/collections/${handle}?view=ajax`)
//         .then(res => res.text())
//         .then(data => {
//           container.innerHTML = data;
//           container.dataset.loaded = "true";
//         });
//     });
//   });

// });


document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".tab-link-nav-cstm");
  const contents = document.querySelectorAll(".tab-content-inner-wrap");

  // 100px offset scroll (SECTION level)
  function scrollToSection(element, offset = 100) {
    const section = element.closest("section");
    if (!section) return;

    const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  function openTab(tabHandle, shouldScroll = false) {

    const targetContent = document.querySelector(
      '.tab-content-inner-wrap[data-content="' + tabHandle + '"]'
    );

    const targetTab = document.querySelector(
      '.tab-link-nav-cstm[data-tab="' + tabHandle + '"]'
    );

    if (!targetContent || !targetTab) return;

    // Remove active
    tabs.forEach(tab => tab.classList.remove("active"));
    contents.forEach(content => content.classList.remove("active"));

    // Add active
    targetTab.classList.add("active");
    targetContent.classList.add("active");

    // Scroll only when required (hash case)
    if (shouldScroll) {
      setTimeout(() => {
        scrollToSection(targetContent, 100);
      }, 200);
    }
  }

  // ✅ Tab click → NO SCROLL
  tabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      const tabHandle = this.getAttribute("data-tab");

      history.pushState(null, null, "#" + tabHandle);

      openTab(tabHandle, false); // false = no scroll
    });
  });

  // ✅ On page load (if hash present → scroll)
  function handleHashOnLoad() {
    const hash = window.location.hash.replace("#", "");

    if (hash) {
      openTab(hash, true); // true = scroll
    } else {
      const firstTab = tabs[0]?.getAttribute("data-tab");
      if (firstTab) openTab(firstTab, false);
    }
  }

  handleHashOnLoad();

  // ✅ On hash change (manual change)
  window.addEventListener("hashchange", function () {
    const hash = window.location.hash.replace("#", "");
    if (hash) openTab(hash, true);
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-promo"] && !Shopify.designMode) return;
  try {
    

// document.getElementById("popup-form").addEventListener("submit", function(e){
//   e.preventDefault();

//   var formData = new FormData();
//   formData.append("form_type", "create_customer");
//   formData.append("utf8", "✓");
//   formData.append("customer[first_name]", this.first_name.value);
//   formData.append("customer[phone]", this.phone.value);
//   formData.append("customer[email]", "dummy" + Date.now() + "@gmail.com");
//   formData.append("customer[password]", "123456");
//   formData.append("customer[tags]", "popup-lead");

//   fetch("/account", {
//     method: "POST",
//     body: formData
//   }).then(() => {
//     alert("Thank you!");
//   });
// });


    function hasPromoModalShown() {
  return sessionStorage.getItem("promoModalShownNew") === "yes";
}

function showPromoModal() {
  var modal = document.getElementById("promoModal");
  if (!modal) {
    return;
  }

  modal.style.display = "flex";
  document.body.style.overflow = "hidden";

  // Mark as shown
  sessionStorage.setItem("promoModalShownNew", "yes");
}

document.addEventListener("DOMContentLoaded", function () {

  var modalPromo = document.getElementById("promoModal");
  if (!modalPromo) {
    return;
  }


  // Show only once per session
  if (!hasPromoModalShown()) {
    showPromoModal();
  }

  // Close button
  var closeBtn = modalPromo.querySelector(".modal_close_promo");
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      modalPromo.style.display = "none";
      document.body.style.overflow = "";
    });
  } else {
    console.log("⚠️ Close button not found");
  }

  // Click outside to close
  var overlay = modalPromo.querySelector(".universal-modal__overlay");
  if (overlay) {
    overlay.addEventListener("click", function () {
      modalPromo.style.display = "none";
      document.body.style.overflow = "";
    });
  } else {
    console.log("⚠️ Overlay not found");
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["time-counter"] && !Shopify.designMode) return;
  try {
    
function initCountdown() {
  const bannerEl = document.getElementById('banner-section');
  if (!bannerEl) return;

  const rawDate = bannerEl.dataset.endDate; // "2025-12-31"
  const rawTime = bannerEl.dataset.endTime || '23:59'; // "18:30"

  if (!rawDate) {
    console.error('Countdown: End date missing');
    return;
  }

  // 🔥 SAFE date + time parsing (all browsers)
  const [year, month, day] = rawDate.split('-').map(Number);
  const [hour, minute] = rawTime.split(':').map(Number);

  const endDate = new Date(year, month - 1, day, hour, minute, 0);

  console.log('Countdown End →', endDate.toString());

  setupDigitDOM();
  startCountdown(endDate);
}

// Add digit spans 0–9
function setupDigitDOM() {
  const digitElement = document.querySelectorAll('.banner-countdown__digit');

  digitElement.forEach((el) => {
    const digitWrapper = document.createElement('span');
    digitWrapper.classList.add('banner-countdown__digit-num');

    for (let x = 0; x <= 9; x++) {
      const digitItem = document.createElement('span');
      digitItem.innerText = x;
      digitWrapper.appendChild(digitItem);
    }

    el.innerHTML = '';
    el.appendChild(digitWrapper);
  });
}

// Start countdown interval
function startCountdown(endDate) {
  setInterval(() => {
    makeCountdown(endDate, false);
  }, 1000);
}

// Main countdown math
function makeCountdown(endTime, hideDaysIfEmpty = false) {
  const endTimeStamp = endTime.getTime() / 1000;
  const nowStamp = Date.now() / 1000;

  let timeLeft = endTimeStamp - nowStamp;

  let days = Math.floor(timeLeft / 86400);
  let hours = Math.floor((timeLeft % 86400) / 3600);
  let minutes = Math.floor((timeLeft % 3600) / 60);
  let seconds = Math.floor(timeLeft % 60);

  if (timeLeft < 0) {
    days = hours = minutes = seconds = 0;
  }

  hours = hours.toString().padStart(2, '0');
  minutes = minutes.toString().padStart(2, '0');
  seconds = seconds.toString().padStart(2, '0');

  if (days === 0 && hours === "00" && minutes === "00" && seconds === "00") {
    const timerBlock = document.querySelector('.top-announce-timer-main');
    if (timerBlock) timerBlock.classList.add('timer-ended');
  }

  if (days <= 0 && hideDaysIfEmpty) {
    const dayElement = document.querySelector('#timer-day');
    if (dayElement) dayElement.style.display = 'none';
  } else {
    updateCountdown(days, 'timer-day');
  }

  updateCountdown(hours, 'timer-hour');
  updateCountdown(minutes, 'timer-minute');
  updateCountdown(seconds, 'timer-second');
}

// Update UI animation
function updateCountdown(value, elementId) {
  const element = document.querySelector(`#${elementId}`);
  if (!element) return;

  const firstDigitElement = element.querySelector('.banner-countdown__digit-first > span');
  const secondDigitElement = element.querySelector('.banner-countdown__digit-second > span');

  if (!firstDigitElement || !secondDigitElement) return;

  const digitHeight = secondDigitElement.offsetHeight / 10;
  let digits = value.toString().padStart(2, '0').split('').map(Number);

  if (elementId === 'timer-day') {
    const hundredDigit = element.querySelector('.banner-countdown__digit-hundred > span');
    if (value >= 100 && hundredDigit) {
      const [h, f, s] = value.toString().split('').map(Number);
      hundredDigit.style.transform = `translateY(-${h * digitHeight}px)`;
      digits = [f, s];
    }
  }

  firstDigitElement.style.transform = `translateY(-${digits[0] * digitHeight}px)`;
  secondDigitElement.style.transform = `translateY(-${digits[1] * digitHeight}px)`;
}

document.addEventListener('DOMContentLoaded', initCountdown);
document.addEventListener('shopify:section:load', initCountdown);

  } catch(e) { console.error(e); }
})();
})();
